<template>
  <Loader v-if="loading" :inverse="true"></Loader>
  <template v-else>
    <div class="step-body">
      <p class="step-title">Review Request</p>
      <p class="step-desc">
        Your request has not yet been submitted. Confirm the information is correct.
      </p>
      <div class="body-content review-content">
        <div class="form-group table-container">
          <table id="review-request">
            <thead>
              <th>School Name:</th>
              <th>Funding Term:</th>
              <th>Enrollment:</th>
              <th>Requested Amount:</th>
            </thead>
            <tbody>
              <tr v-for="(disbursement, index) of DISBURSEMENTS" :key="index">
                <td>
                  <div class="value-display">
                    <label>School Name:</label>
                    <p class="value">
                      {{ disbursement.schoolName }}
                    </p>
                  </div>
                </td>
                <td>
                  <div class="value-display">
                    <label>Funding Term:</label>
                    <p class="value">
                      {{ disbursement.enrollmentTerm }}
                    </p>
                  </div>
                </td>
                <td>
                  <div class="value-display">
                    <label>Enrollment:</label>
                    <p class="value">
                      {{ disbursement.enrollmentStatusName }}
                    </p>
                  </div>
                </td>
                <td>
                  <div class="value-display">
                    <label>Requested Amount:</label>
                    <p class="value">
                      {{ disbursement.requestedAmount }}
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="form-check" v-if="isParentLOC">
        <input
          class="form-check-input"
          type="checkbox"
          id="parentAttestation"
          v-model="parentConsent"
        />
        <label class="form-check-label" for="parentAttestation">
          By checking this box, you affirm that you are the student's parent or legal guardian and
          that you claim the student as a dependent on your tax return.
        </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          id="confirmRequest"
          v-model="reviewConfirmation"
        />
        <label class="form-check-label" for="confirmRequest">
          I confirm the above information.
        </label>
      </div>
      <div v-if="error" class="submit-error">
        <p v-if="postErrors.length <= 0">
          Something has gone wrong submitting your request. If you continue to receive this error,
          please contact support.
        </p>
        <ul v-else>
          <p>
            Something has gone wrong submitting your request. If you continue to receive this error,
            please contact support.
          </p>
          <li v-for="(error, index) of postErrors" :key="index">
            {{ error }}
          </li>
        </ul>
      </div>
    </div>
  </template>
  <template v-if="!loading">
    <div class="step-btns">
      <button
        type="button"
        class="btn btn-secondary"
        :disabled="loading || previousButtonDisabled"
        @click.prevent="$emit('goback')"
      >
        Go Back
      </button>
      <button
        type="button"
        class="btn btn-primary btn-sm cuscd-button-color-cta"
        :disabled="
          !reviewConfirmation || loading || submittingRequest || (isParentLOC && !parentConsent)
        "
        @click.prevent="submitRequest"
      >
        Submit
      </button>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { mapGetters, useStore } from "vuex";
import { $api } from "@/services/api";
import Loader from "@/components/shared/Loader.vue";
import useApplicationData from "@/composables/useApplicationData";

export default defineComponent({
  setup() {
    const store = useStore();
    const submittingRequest = ref<boolean>(false);
    const previousButtonDisabled = ref<boolean>(false);
		
    const { isParentLOC } = useApplicationData();

    return {
      store,
      submittingRequest,
      previousButtonDisabled,
      isParentLOC,
    };
  },
  components: { Loader },
  emits: ["goback", "complete", "getLoanDetails"],
  props: {
    referenceId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: true as boolean,
    error: false as boolean,
    reviewConfirmation: false as boolean,
    parentConsent: false as boolean | undefined,
    postErrors: [] as string[],
  }),
  computed: {
    ...mapGetters("fundsModule", ["DISBURSEMENTS", "DrawRequest"]),
  },
  methods: {
    async submitRequest() {
      console.log("this.DrawRequest", this.DrawRequest);

      const body = this.DrawRequest;
      this.error = false;
      this.submittingRequest = true;
      this.previousButtonDisabled = true;

      $api.originator
        .postDrawRequest(this.referenceId, body)
        .then((result: any) => {
          if (result.error) {
            this.error = true;
            this.postErrors = [result.msg];
          } else {
            this.store.commit("fundsModule/resetAllStates");
            this.submittingRequest = false;
            this.loading = false;
            this.$emit("complete");
          }
        })
        .catch(error => {
          this.error = true;
          console.error(error);
        });

      this.previousButtonDisabled = false;
    },
  },
  mounted() {
    this.loading = false;
  },
});
</script>
